import { SigninRequest } from '@interfaces/auth.interface';
import { UserWithPermissions } from '@interfaces/users.interface';

import api from './';

export const { useGetCurrentUserQuery, useSigninMutation, useLogoutMutation } =
  api.injectEndpoints({
    endpoints: (build) => ({
      getCurrentUser: build.query<UserWithPermissions, void>({
        query: () => ({ url: 'auth/me' }),
      }),
      signin: build.mutation<UserWithPermissions, SigninRequest>({
        query: ({ body, recaptchaToken }) => ({
          url: 'auth/signin',
          method: 'POST',
          body,
          headers: {
            'x-grecaptcha': recaptchaToken,
          },
        }),
      }),
      logout: build.mutation<void, void>({
        query: (body) => ({
          url: 'auth/logout',
          method: 'POST',
          body,
        }),
      }),
    }),
  });
